export const reimbursementCategories = [
  ['airfare', 'Airfare'], ['transportation', 'Transportation (Rideshare, taxi, train, bus, etc)'],
  ['parking', 'Parking'], ['travel-per-diem', 'Travel Day per diem'], ['per-diem', 'Per diem'],
  ['airfare-extras', 'Airfare Extras (baggage, seats, etc)'], ['accommodation', 'Accommodation (Hotel, Airbnb, etc)'],
] as const;
export type CategorySelection = { version: 1; key: string; customName?: string; city?: string; rate?: string | number; days?: string | number };
export function categoryPreview(value?: CategorySelection | null): number | undefined {
  if (!value || !['per-diem', 'travel-per-diem'].includes(value.key)) return undefined;
  const rate = Number(value.rate), days = Number(value.days);
  if (!Number.isFinite(rate) || rate <= 0 || !Number.isSafeInteger(days) || days <= 0) return undefined;
  return Math.round(Math.round(rate * 100) * days * (value.key === 'travel-per-diem' ? 75 : 100) / 100) / 100;
}
